import React, { HTMLAttributes, forwardRef } from 'react';
import './Card.css';

export type CardVariant = 'default' | 'elevated' | 'outlined' | 'flat';

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  variant?: CardVariant;
  padding?: 'none' | 'sm' | 'md' | 'lg';
  as?: React.ElementType;
}

export const Card = forwardRef<HTMLDivElement, CardProps>(function Card(
  {
    variant = 'default',
    padding = 'md',
    as: Tag = 'div',
    className = '',
    children,
    ...rest
  },
  ref,
) {
  const classes = [
    'card',
    `card--${variant}`,
    padding !== 'none' ? `card--padding-${padding}` : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <Tag ref={ref} className={classes} {...rest}>
      {children}
    </Tag>
  );
});

Card.displayName = 'Card';
